import React from 'react';

import { Typography } from '@mui/material';

import useFlowActivityMetadata from '../Hooks/Metadata/useFlowActivityMetadata';
import DisplayContentTemplate from './DisplayContentTemplate';

export interface ActivityNameDisplayProps {
	activityId: string | undefined;
	getActivityType: (activityId: string | undefined) => string | undefined;
	getActivityData: (activityId: string | undefined) => any;
	variant?: 'body2' | 'body1' | 'subtitle2';
	sx?: any;
	showActivityId?: boolean;
}

/**
 * Component to display activity name using metadata and DisplayContentTemplate.
 * Supports templated display content with interpolated context data.
 */
export default function ActivityNameDisplay({
	activityId,
	getActivityType,
	getActivityData,
	variant = 'body2',
	sx,
	showActivityId = true,
}: ActivityNameDisplayProps) {
	const activityType = getActivityType(activityId);
	const activityMetadata = useFlowActivityMetadata(activityType ?? '');
	const activityData = getActivityData(activityId);

	return (
		<Typography variant={variant} sx={sx}>
			{!activityId && 'Unknown Activity'}
			{activityId && (
				<DisplayContentTemplate
					template={activityMetadata?.displayContent}
					fallbackText={activityMetadata?.displayName ?? activityType ?? (showActivityId ? activityId : 'Unknown Activity')}
					context={activityData}
					className="activity-name"
				/>
			)}
		</Typography>
	);
}
